import React from 'react';
import {
  Brief,
  Button,
  CondensedMedium,
  Grid,
  GridColumn,
  Gutter,
  Layout,
  LayoutItem,
} from '@axiom/ui';

import { ChatMetric } from '../../enums/chat-metric';
import type { ChatAttachment as ChatAttachmentType } from '../../types/chat.types';
import { ChatAttachmentList } from '../ChatAttachmentList/ChatAttachmentList';

export type ChatAttachmentsProps = {
  attachments: ChatAttachmentType[];
  clearAttachments: () => void;
  removeAttachment: (attachmentId: string) => void;
};

export const ChatAttachments = ({
  attachments,
  clearAttachments,
  removeAttachment,
}: ChatAttachmentsProps) => {
  if (attachments.length === 0) return null;

  return (
    <Gutter bottom="12px" gutterType="margin">
      <Grid>
        <GridColumn width={6}>
          <Layout
            direction="vertical"
            name="CHAT_ATTACHMENTS"
            verticalGutter="8px"
          >
            <Layout horizontalGutter="8px" position="middle">
              {/* Lines the count up with the chip contents below, which the `Well` insets. */}
              <LayoutItem fluid leftGutter="8px">
                <CondensedMedium name="CHAT_ATTACHMENT_COUNT">
                  {attachments.length === 1
                    ? 'Attachment'
                    : `Attachments (${attachments.length})`}
                </CondensedMedium>
              </LayoutItem>
              {attachments.length > 1 ? (
                <Button
                  name="CLEAR_ATTACHMENTS"
                  onClick={() => {
                    clearAttachments();
                  }}
                  pattern="primary"
                  variation="minimal"
                >
                  Clear all
                </Button>
              ) : null}
            </Layout>
            <Brief
              briefMaxHeight={ChatMetric.SHELF_MAX_HEIGHT}
              name="CHAT_ATTACHMENT_SHELF"
              position="right"
              variation="minimal"
            >
              <ChatAttachmentList
                attachments={attachments}
                name="CHAT_ATTACHMENT_LIST"
                removeAttachment={removeAttachment}
              />
            </Brief>
          </Layout>
        </GridColumn>
      </Grid>
    </Gutter>
  );
};
